import Request from './request'

const Comments  = {
  getComments(params, callback) {
    Request.get('comments/list', params).then(callback).catch(this.bad_answer)
  },
  addComment(params, callback, bad_answer) {
    Request.post('comments/create', JSON.stringify(params)).then(callback).catch(bad_answer)
  },
  editComment(params, callback) {
    Request.put('comments/update', JSON.stringify(params)).then(callback).catch(this.bad_answer)
  },
  deleteComment(id, callback, bad_answer) {
    Request.get('comments/hide/' + id).then(callback).catch(bad_answer)
  },
  pinComment(id, params, callback, bad_answer) {
    Request.request('PUT', 'comments/pin/' + id, new URLSearchParams(params).toString(), false, {
      headers: {'Content-type': 'application/x-www-form-urlencoded'}
    }).then(callback).catch(bad_answer)
  },
}

export default Comments
